import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../client/reducers'
import { setStoreGetter } from '../client/common/productImageUtils';
let store = null;

export default (state = {}) => {
	store = createStore(reducers, state, applyMiddleware(thunk));
	setStoreGetter(getStore);
	return store;
};

export function getStore() {
	return store;
}

export function getSessionStore() {
	return store.getState().session;
}

export function getProductsStore() {
	return store.getState()?.products;
}